import React from 'react';
import {Typography} from '@deere/fuel-react';

export const FeedbackViewComments = ({comments}) => {
    return <>
        {comments ? (
            <Typography variant="body1">
                {comments}
            </Typography>
        ) : (
            <Typography size="sm" component="span" color="tertiary">
                No Comments
            </Typography>
        )
        }
    </>;
}
